import { render, staticRenderFns } from "./PoliciesModal.vue?vue&type=template&id=35ed591a&scoped=true&"
import script from "./PoliciesModal.vue?vue&type=script&lang=js&"
export * from "./PoliciesModal.vue?vue&type=script&lang=js&"
import style0 from "./PoliciesModal.vue?vue&type=style&index=0&id=35ed591a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed591a",
  null
  
)

export default component.exports